<template>
  <CommonPages id="home" classs="home">
    <div class="page-top-row sort"
      :class="[`design-type-${domainConfig?.designType || 1}`, { 'page-top-row-m': deviceType === 'mobile' }]">
      <div class="page-top-inner pc_padding m_padding">
        <div class="page-head-h1">
          {{ pageTitle }}
        </div>
        <div class="page-head-descript">
          {{ pageDescription }}
        </div>
      </div>
    </div>

    <div class="section-content-container " :class="`design-type-${domainConfig?.designType || 1}`">
      <AdComponent
        v-if="deviceType != 'mobile' && $global.isObjectNotEmpty(adsensConfig) && adsensConfig?.sort_insert?.[0]"
        ref="ads-card-insert-1" class="ads-insert-max pc_padding padding-horizon-40"
        :ads="adsensConfig?.sort_insert?.[0]" :showDebug="showDebug" />
      <div class="section-content-inner pc_padding m_padding">
        <div class="card-listed-content-row">
          <template v-for="(item, index) in recommandList">
            <AdComponent v-if="shouldInsertAdDevice('sort_insert', index) !== -1"
              :key="`ad_${index}`" :ref="`ads-card-insert-${index}`"
              class="ads-card-insert ad-width-100 ads-insert"
              :ads="adsensConfig?.sort_insert?.[shouldInsertAdDevice('sort_insert', index)]"
              :showDebug="showDebug" @adLoaded="(e) => handleAdLoad('sort_insert', index, e)"
              @adError="(e) => handleAdError('sort_insert', index, e)" />
            <div :key="item.id" class="card-viewd cursor" @click="gotoDetail(item)">
              <img v-lazy="item.imageUrl" :alt="item.name" class="card-viewd-image">
              <div class="card-viewd-details">
                <div class="card-viewd-title">
                  {{ item.name }}
                </div>
                <div class="card-viewd-type">
                  {{ item.type }}
                </div>
                <ul class="card-viewd-benefits">
                  <li>Annual Fee: {{ item.annualFeeStr }}</li>
                  <li>Reward Rate: {{ item.rewardRateStr }}</li>
                  <li>Sign-up Bonus: {{ item.signupBonusStr }}</li>
                </ul>
              </div>
              <a href="javascript:;" class="card-viewd-link"
                :class="`design-type-${domainConfig?.designType || 1}`">Learn More →</a>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-if="deviceType != 'mobile'" class="pagination">
      <div class="page-brother cursor" :class="{ hide: page === 1 }" @click="prevPage">
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12"
          fill="none">
          <path
            d="M0 5.94262C0.00780488 5.89476 0.0156096 5.84691 0.0312193 5.79905C0.0624389 5.67599 0.140488 5.5666 0.234146 5.47772L0.280976 5.4367L6.45463 0.23392C6.64976 0.0698377 6.86829 -0.0122035 7.14146 0.00147004C7.61756 0.0151436 8.0078 0.384329 7.96878 0.780862C7.95317 0.972291 7.85171 1.13637 7.69561 1.27311L2.13854 5.94946C2.12293 5.96313 2.10732 5.96997 2.0761 5.99732C2.10732 6.01099 2.13073 6.01783 2.14634 6.0315C4.0039 7.59028 5.85366 9.1559 7.71122 10.7147C7.85951 10.8446 7.96878 10.995 7.99219 11.1728C7.99219 11.1796 8 11.1796 8 11.1864V11.3437C8 11.3505 7.99219 11.3573 7.99219 11.371C7.93756 11.665 7.69561 11.8974 7.3522 11.9727L7.21951 12H7.0322C7.0322 11.9932 7.02439 11.9932 7.01658 11.9932C6.79805 11.9727 6.61854 11.8838 6.47024 11.747C6.0722 11.4052 5.66634 11.0702 5.26049 10.7284C3.61366 9.3405 1.96683 7.9458 0.312195 6.55793C0.218536 6.48273 0.140488 6.39385 0.101463 6.2913C0.0624389 6.19558 0.0312195 6.09987 0 6.00415V5.94262Z"
            fill="#333333" />
        </svg>
      </div>
      <div v-for="(pageNum, index) in pageNumbers" :key="index"
        :class="`pagination-item cursor  type-${domainConfig?.['designType']}`">
        <div v-if="pageNum !== '...'" class="pagination-item-num"
          :class="{ active: page === pageNum }" @click="goToPage(pageNum)">
          {{ pageNum }}
        </div>
        <div v-else class="pagination-item-more">
          ...
        </div>
      </div>
      <div class="page-brother cursor" :class="{ hide: page === totalPages }" @click="nextPage">
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12"
          fill="none">
          <path
            d="M8 5.94262C7.9922 5.89476 7.98439 5.84691 7.96878 5.79905C7.93756 5.67599 7.85951 5.5666 7.76585 5.47772L7.71902 5.4367L1.54537 0.23392C1.35024 0.0698377 1.13171 -0.0122035 0.858537 0.00147004C0.382439 0.0151436 -0.00780487 0.384329 0.031219 0.780862C0.0468287 0.972291 0.148293 1.13637 0.30439 1.27311L5.86146 5.94946C5.87707 5.96313 5.89268 5.96997 5.9239 5.99732C5.89268 6.01099 5.86927 6.01783 5.85366 6.0315C3.9961 7.59028 2.14634 9.1559 0.28878 10.7147C0.140487 10.8446 0.03122 10.995 0.00780535 11.1728C0.00780535 11.1796 0 11.1796 0 11.1864V11.3437C0 11.3505 0.00780535 11.3573 0.00780535 11.371C0.0624394 11.665 0.30439 11.8974 0.647804 11.9727L0.780488 12H0.967804C0.967804 11.9932 0.97561 11.9932 0.983415 11.9932C1.20195 11.9727 1.38146 11.8838 1.52976 11.747C1.9278 11.4052 2.33366 11.0702 2.73951 10.7284C4.38634 9.3405 6.03317 7.9458 7.68781 6.55793C7.78146 6.48273 7.85951 6.39385 7.89854 6.2913C7.93756 6.19558 7.96878 6.09987 8 6.00415V5.94262Z"
            fill="#333333" />
        </svg>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import CommonPages from '@/pages/components/page_common.vue'
import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    AdComponent,
    CommonPages,
  },
  mixins: [common, adMixin, adTrackingMixin],
  props: {
    channel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      cards: [],
      iconMapping: {
        '0% APR Credit Cards': require("@/assets/1.png"),
        'No Annual Fee Credit Cards': require("@/assets/2.png"),
        'Balance Transfer Credit Cards': require("@/assets/3.png"),
        'Travel Credit Cards': require("@/assets/4.png"),
        'Airline Credit Cards': require("@/assets/5.png"),
        'Cash Back Credit Cards': require("@/assets/6.png"),
        'Rewards Credit Cards': require("@/assets/7.png"),
        'Business Credit Cards': require("@/assets/8.png"),
        'Student Credit Cards': require("@/assets/9.png"),
      },
      classMapping: {
        '0% APR Credit Cards': 'apr-item',
        'No Annual Fee Credit Cards': 'no-annual-fee-item',
        'Balance Transfer Credit Cards': 'balance-transfer-item',
        'Travel Credit Cards': 'travel-item',
        'Airline Credit Cards': 'airline-item',
        'Cash Back Credit Cards': 'cash-back-item',
        'Rewards Credit Cards': 'rewards-item',
        'Business Credit Cards': 'business-item',
        'Student Credit Cards': 'student-item',
      },
      recommandList: [],
      /////////列表示例
      hasNext: true,
      page: 1,
      totalPages: null,
      observedAds: null,
      isLoading: false,
      scrollThreshold: 2000, // 滚动触发阈值
      currentType: '',
      currentChannel: '',
      pageTitle: '',
      pageDescription: '',
      typeDescriptions: {
        '0% APR Credit Cards': {
          title: '0% APR Credit Cards Review',
          description: 'Find the best 0% APR credit cards to help manage your finances. Compare introductory offers, balance transfer options, and ongoing rates to choose the perfect card for your needs.'
        },
        'No Annual Fee Credit Cards': {
          title: 'No Annual Fee Credit Cards Review',
          description: 'Discover credit cards with no annual fees that still offer great rewards and benefits. Compare cards to find the one that matches your spending habits without extra costs.'
        },
        'Balance Transfer Credit Cards': {
          title: 'Balance Transfer Credit Cards Review',
          description: 'Looking to consolidate debt? Compare the best balance transfer credit cards with competitive intro APR periods and transfer fees to find your ideal match.'
        },
        'Travel Credit Cards': {
          title: 'Travel Credit Cards Review',
          description: 'Explore premium travel credit cards offering rewards on flights, hotels, and more. Find cards with travel insurance, airport lounge access, and other exclusive benefits.'
        },
        'Airline Credit Cards': {
          title: 'Airline Credit Cards Review',
          description: 'Compare airline-specific credit cards offering mile rewards, priority boarding, free checked bags, and other travel perks to enhance your flying experience.'
        },
        'Cash Back Credit Cards': {
          title: 'Cash Back Credit Cards Review',
          description: 'Maximize your returns with cash back credit cards offering rewards on everyday purchases. Compare different reward rates and categories to find the best card for your spending.'
        },
        'Rewards Credit Cards': {
          title: 'Rewards Credit Cards Review',
          description: 'Discover versatile rewards credit cards offering points or miles on various purchase categories. Compare cards to find the best rewards program for your lifestyle.'
        },
        'Business Credit Cards': {
          title: 'Business Credit Cards Review',
          description: 'Find the ideal business credit card with rewards on office supplies, travel, and other business expenses. Compare cards offering expense management tools and employee cards.'
        },
        'Student Credit Cards': {
          title: 'Student Credit Cards Review',
          description: 'Start building your credit history with student credit cards designed for college students. Compare cards offering student-specific benefits and rewards on everyday purchases.'
        }
      },
      adLoadStatus: {
        sort_insert: new Map()
      }
    };
  },
  computed: {
    title () {
      return `${this.currentType}${this.domainConfig?.['meta']?.title || 'Default Title'}`
    },
    description () {
      return `${this.domainConfig?.['meta']?.des || 'Default des'}`
    },
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
    ]),
    pageNumbers () {
      const total = this.totalPages || 0; // 确保 totalPages 有默认值
      const current = this.page || 1; // 确保 page 有默认值
      let pages = [];

      if (total <= 1) {
        return [1];
      }

      pages.push(1);

      let startPage = Math.max(current - 1, 2);
      let endPage = Math.min(current + 1, total - 1);

      if (startPage > 2) {
        pages.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < total - 1) {
        pages.push('...');
      }

      pages.push(total);

      return pages;
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler (newRoute) {
        // 添加空值检查
        if (newRoute.params && newRoute.params.type) {
          const type = newRoute.params.type.replace(/-/g, ' ');
          this.currentType = type;
          this.currentChannel = newRoute.params.channel || '';

          // 设置页面标题和描述
          if (this.typeDescriptions?.[type]) {
            this.pageTitle = this.typeDescriptions[type].title;
            this.pageDescription = this.typeDescriptions[type].description;
          } else {
            // 默认标题和描述
            this.pageTitle = `${type} Review`;
            this.pageDescription = `Discover the benefits of ${type} to find the ideal choice for your financial goals.`;
          }

          this.page = 1;
          // this.getCardList();
        } else {
          // 如果没有type参数，可以重定向到首页或者显示错误信息
          console.warn('No type parameter provided');
          this.$router.push({ name: 'home' });
        }
      }
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          content: this.description,
        },
        {
          property: 'og:title',
          content: this.title,
        },
        {
          property: 'og:description',
          content: this.description,
        },
      ],
    };
  },
  created () {
    //获取参数示例
    // const { paramsName } = this.$route.params;
    // console.log(`paramsName: ${paramsName}`);
  },
  async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
  async mounted () {
    console.log(`[${this.$options.name}] mounted`)
    await this.initAdSystem()

    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking()
    })
    if (this.currentType) {
      this.getCardList()
    } else {
      this.retryGetParams()
    }
  },
  deactivated () {
    console.log(`[${this.$options.name}] deactivated`)
  },
  beforeDestroy () {
    console.log(`[${this.$options.name}] beforeDestroy`)
    // 清理定时器和事件监听
    if (this.checkInterval) {
      clearInterval(this.checkInterval); //客户端交互移除
    }
    if (this.visibilityChangeHandler) {
      document.removeEventListener('visibilitychange', this.visibilityChangeHandler);//客户端交互移除
    }
  },
  methods: {
    //页面方法 ...

    // 优化后的滚动方法
    onScroll () {
      if (this.isLoading || !this.hasNext) return;

      const {
        scrollHeight,
        scrollTop,
        clientHeight
      } = document.documentElement;

      if (scrollHeight - scrollTop - clientHeight < this.scrollThreshold) {
        this.loadMoreData();
      }
    },

    async loadMoreData () {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.getImages();
      } catch (err) {
        console.error('加载数据失败:', err);
      } finally {
        this.isLoading = false;
      }
    },

    async getCardList () {
      // 添加类型检查
      if (!this.currentType) {
        console.warn('No type specified for getCardList');
        return;
      }

      try {
        const params = {
          type: this.currentType,
          recommendNum: 4,
          pageNum: this.page,
          pageSize: 8,
          ...(this.currentChannel && { channel: this.currentChannel })
        };

        const res = await this.$global.server.getCardList(params);

        if (res.code === 200) {
          console.log(res.data);
          const { cards } = res.data;
          this.recommandList = cards
          this.hasNext = res.data.hasNext ?? false;
          this.totalPages = res.data.totalNum ?? 0;
          this.$nextTick(() => this.setupAdObserver());
        }
      } catch (err) {
        console.error('获取图片失败:', err);
        throw err;
      }
    },
    prevPage () {
      if (this.page > 1) {
        this.page--;
        this.updateData();
      }
    },
    nextPage () {
      if (this.page < this.totalPages) {
        this.page++;
        this.updateData();
      }
    },
    goToPage (pageNum) {
      if (pageNum !== '...') {
        this.page = pageNum;
        this.updateData();
      }
    },
    updateData () {
      // 根据当前页更新数据的逻辑
      console.log(this.page);
      this.getCardList()
    },

    getCardIcon (name) {
      return this.iconMapping[name] || require("@/assets/1.png") // 默认图标
    },

    getCardClass (name) {
      return this.classMapping[name] || 'default-item' // 默认class
    },

    // 防抖函数 + 滚动
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },

    //跳转
    goto (name) {
      this.$router.push({ name: name });
    },

    shouldInsertAdDevice (pos, index) {
      // 如果没有广告配置,直接返回 -1
      if (!this.adPosConfig?.[pos]) {
        return -1
      }

      const position = index + 1
      const config = this.adPosConfig[pos]

      // 移动端和PC端使用不同的广告位置配置
      const adPositions = this.deviceType === 'mobile' ? config : -1

      if (!Array.isArray(adPositions)) {
        return -1
      }

      const adIndex = adPositions.indexOf(position)

      // 检查对应位置是否有广告配置
      if (adIndex !== -1 && !this.adsensConfig?.[pos]?.[adIndex]) {
        // console.warn(`Missing ad config for position ${pos} index ${adIndex}`)
        return -1
      }

      return adIndex
    },

    // 用于其他页面跳转的辅助方法
    getFullPath (path) {
      const currentParams = this.$router.currentRoute.params;
      const currentQuery = this.$route.query;

      const channel = currentParams.channel ? `/${currentParams.channel}` : '';
      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      return `${channel}${path}${fullQueryString}`;
    },

    gotoDetail (item) {
      const formattedType = encodeURIComponent(item.type.replace(/\s+/g, '-'));
      const formattedName = encodeURIComponent(item.name.replace(/\s+/g, '-'));
      const currentParams = this.$router.currentRoute.params;
      const currentQuery = this.$route.query;

      const channel = currentParams.channel ? `/${currentParams.channel}` : '';
      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      const baseUrl = window.location.origin;
      const fullPath = `${baseUrl}${channel}/${formattedType}/${formattedName}/${item.id}${fullQueryString}`;

      window.location.href = fullPath;
    },

    retryGetParams () {
      const retryInterval = 1000; // 重试间隔时间，单位毫秒
      const maxRetries = 5; // 最大重试次数
      let retryCount = 0;

      const retry = setInterval(() => {
        if (this.currentType) {
          clearInterval(retry);
          this.getCardList();
        } else {
          retryCount++;
          console.warn(`Retrying to get parameters... (${retryCount}/${maxRetries})`);

          if (retryCount >= maxRetries) {
            clearInterval(retry);
            console.error('Failed to get parameters after maximum retries.');
            this.$router.push({ name: 'home' });
          }
        }
      }, retryInterval);
    },

    handleAdLoad (position, index, event) {
      // 简化的广告加载处理
      this.$eventrack?.('ad_load_success', 'expose', {
        position,
        index,
        loadTime: event.loadTime,
        adSlot: this.adsensConfig?.[position]?.[index]?.['data-ad-slot']
      })
    },

    handleAdError (position, index, event) {
      // 简化的错误处理
      this.$eventrack?.('ad_load_fail', 'error', {
        position,
        index,
        error: event.error,
        attempts: event.attempts,
        adSlot: event.adSlot
      })
    },
  }
};
</script>
